import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function PasswordGate() {
  const { me } = useAuth();
  const { pathname } = useLocation();
  if (me?.user?.must_change_password && pathname !== "/account/security") return <Navigate to="/account/security" replace />;
  return null;
}
